<div class="modal-body">
  <h5 class="modal-title">{{ title || "Bevestig" }}</h5>
  <p [innerHTML]="text || 'Ben je zeker?'"></p>

  <div class="text-end d-flex gap-4 justify-content-center">
    <!-- cancel -->
    <app-button
      class=""
      [name]="cancelText || 'Annuleren'"
      [buttonClass]="'btn-' + cancelColor"
      (click)="activeModal.close(false)"
    ></app-button>
    <!-- confirm -->
    <app-button
      [name]="confirmText || 'Bevestigen'"
      [buttonClass]="'btn-' + confirmColor"
      (click)="activeModal.close(true)"
      focus
    ></app-button>
    @if (confirmSecondaryText) {
      <app-button
        [name]="confirmSecondaryText"
        [buttonClass]="'btn-' + confirmColor"
        (click)="activeModal.close('secondary')"
        focus
      ></app-button>
    }
  </div>
</div>
